import { heroBanner, movies, siteStats } from "@/mocks/movies";
import type { Movie } from "@/pages/home/types";

const featured = movies.filter((m) => m.rank !== null && m.rank <= 4) as Movie[];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroBanner}
          alt=""
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/85" />
      </div>

      <div className="relative mx-auto w-full max-w-[1280px] px-4 pb-16 pt-28 md:px-8 md:pb-20 md:pt-36">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/20 px-3 py-1 text-xs font-medium text-accent-200 md:text-sm">
            <i className="ri-fire-line" />
            本期片单已更新 · 排行榜 / 高分 / 类型片
          </span>
          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            九七电影院
          </h1>
          <p className="mt-3 font-heading text-lg text-background-100 md:text-2xl">
            排行榜、豆瓣高分与类型片找片指南
          </p>
          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            这里把散落的找片线索收拢到一页：先看本期排行榜与口碑高分，再按动作片、爱情片、恐怖片等类型逐层筛选。
            无需注册、无需跳转，滑一屏就能把想看的片单圈出来。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#ranking"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-trophy-line" />
              查看本期排行榜
            </a>
            <a
              href="#genre"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
            >
              <i className="ri-filter-3-line" />
              按类型筛选影片
            </a>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4">
          {featured.map((movie, index) => (
            <a
              key={movie.id}
              href="#ranking"
              className="qj-rise group block overflow-hidden rounded-lg border border-background-50/15 bg-foreground-950/40 transition-transform duration-300 hover:-translate-y-1"
              style={{ animationDelay: `${index * 90}ms` }}
            >
              <div className="relative h-52 w-full overflow-hidden md:h-72">
                <img
                  src={movie.img}
                  alt={`《${movie.title}》风格封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded-md bg-primary-500 px-2 py-0.5 font-heading text-xs font-bold text-background-50 md:text-sm">
                  NO.{movie.rank}
                </span>
                <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-medium text-accent-300">
                  <i className="ri-star-fill" />
                  {movie.score}
                </span>
              </div>
              <div className="p-3">
                <h2 className="font-heading text-sm font-bold text-background-50 md:text-base">
                  {movie.title}
                </h2>
                <p className="mt-1 text-xs text-background-300">
                  {movie.year} · {movie.region}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 border-t border-background-50/15 pt-8 md:grid-cols-4">
          {siteStats.map((stat) => (
            <div key={stat.label}>
              <p className="font-heading text-2xl font-bold text-accent-400 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-1 text-xs text-background-300 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}